import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import Skeleton from "../../../components/Skeleton";
import NoResultsFound from "../../../components/NoResultsFound";
import Modal from "../../../components/Modal";
import { showToast } from "../../../components/ToastMsg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEdit, faFileDownload, faPlus, faRefresh, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { completeRemainingTickets, downloadRemainingTickets, getRemainingTickets } from "../../../redux/features/tickets/ticketService";
import Pagination from "../../../components/Pagination";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { getAllLotteryBrandDay, getAllLotteryBrandDaysCode } from "../../../redux/features/lotteryBrandDay/lotteryBrandDayService";
import { getAllLotteryBrands } from "../../../redux/features/lotteryBrand/lotteryBrandService";
import DropdownwithValue from "../../../components/DropdownValue";
import BeatLoader from "react-spinners/BeatLoader";
import { downloadTicketReportsList, getTicketReports } from "../../../redux/features/ticketReports/ticketReportsService";
import SearchBar from "../../../components/SearchBar";

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const PaymentStatus = [
    { id: '1', name: 'On Sale' },
    { id: '2', name: 'Sold' },
    { id: '3', name: 'Completed' },
];

const TicketStatus = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Win' },
    { id: '3', name: 'Lose' },
];

const TicketReports = () => {
    const dispatch = useDispatch();
    const brandDropdownRef = useRef(null);
    const brandDayDropdownRef = useRef(null);
    const ticketStatusDropdownRef = useRef(null);
    const paymentStatusDropdownRef = useRef(null);

    const { isTicketReportsLoading, pageCount, ticketReports } = useSelector(
        (state) => state.ticketReport.ticketReports
    );

    const { isFileDownloading } = useSelector(
        (state) => state.ticketReport.ticketReportsFile
    );

    const { isLotteriesLoading, lotteries } = useSelector(
        (state) => state.lottery.allLotteryBrands
    );

    const { isLotteryBrandDayCodeLoading, lotteryBrandDayCode } = useSelector(
        (state) => state.lotteryBrandDay.allLotteryBrandDayCode
    );

    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [brandValue, setBrandValue] = useState(null);
    const [isBrand, setBrand] = useState(false);
    const [brandDayValue, setBrandDayValue] = useState(null);
    const [isBrandDay, setBrandDay] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [drawNo, setDrawNo] = useState('');
    const [ticketStatusValue, setTicketStatusValue] = useState(null);
    const [paymentStatusValue, setPaymentStatusValue] = useState(null);
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const filterAllTicketReports = useCallback(
        (filters = {}) => {
            const params = {
                skip: skip,
                limit: limit,
                created_from: dateFrom,
                created_to: dateTo,
                lottery_brand_code: isBrand && brandValue?.code,
                lottery_brand_day_code: isBrandDay && brandDayValue.code,
                draw_no: drawNo,
                ticket_status: ticketStatusValue?.name,
                payment_status: paymentStatusValue?.name,
                search: searchQuery,
                ...filters,
            };
            dispatch(getTicketReports(params));
        },
        [dispatch, skip, dateFrom, dateTo, brandValue, brandDayValue, drawNo, ticketStatusValue, paymentStatusValue, searchQuery]
    );

    useEffect(() => {
        filterAllTicketReports();
    }, [filterAllTicketReports]);

    useEffect(() => {
        dispatch(getAllLotteryBrands({ status: true }));
    }, [dispatch]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    const handleBrand = (option) => {
        dispatch(getAllLotteryBrandDaysCode({ id: option.code }));
        if (brandDayDropdownRef.current) brandDayDropdownRef.current.clearSelection();
        setBrandDayValue(null);
        setBrandDay(false);
        setBrand(true);
        setBrandValue(option);
        setSkip(1);
    };

    const handleBrandDay = (option) => {
        setBrandDay(true);
        setBrandDayValue(option);
        setSkip(1);
    };

    const handleTicketStatus = (option) => {
        setTicketStatusValue(option);
        setSkip(1);
    };

    const handlePaymentStatus = (option) => {
        setPaymentStatusValue(option);
        setSkip(1);
    };

    const clearAll = () => {
        setSkip(1);
        setBrandDay(false);
        setBrand(false);
        setSearchQuery('');
        setBrandValue(null);
        setBrandDayValue(null);
        setDrawNo('');
        setTicketStatusValue(null);
        setPaymentStatusValue(null);
        setDateFrom();
        setDateTo();
        if (brandDropdownRef.current) brandDropdownRef.current.clearSelection();
        if (brandDayDropdownRef.current) brandDayDropdownRef.current.clearSelection();
        if (ticketStatusDropdownRef.current) ticketStatusDropdownRef.current.clearSelection();
        if (paymentStatusDropdownRef.current) paymentStatusDropdownRef.current.clearSelection();
    }

    const downloadFile = async () => {
        try {
            const params = {
                created_from: dateFrom,
                created_to: dateTo,
                lottery_brand_code: brandValue?.code,
                lottery_brand_day_code: brandDayValue?.code,
                draw_no: drawNo,
                ticket_status: ticketStatusValue?.name,
                payment_status: paymentStatusValue?.name,
            };
            await dispatch(downloadTicketReportsList(params)).unwrap();
        } catch (error) {
            showToast("error", error);
        }
    }

    return (
        <>
            <div className={`card-section`}>
                <div className={`search-card`}>
                    <div className={`search-card-header`} style={{ flexDirection: 'column' }}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <h1 className={`form-title ${styles.headDiv}`}>
                                    Ticket List
                                </h1>
                            </div>
                            <div className={`form-input-col ${styles.downloadBtnCol}`}>
                                <button
                                    className={`btn-primary`}
                                    type='button'
                                    disabled={isFileDownloading}
                                    onClick={downloadFile}
                                >
                                    {isFileDownloading ? (
                                        <BeatLoader grade='#ffffff' />
                                    ) : (
                                        `Download Report`
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Date From
                                    </label>
                                    <input
                                        type="date"
                                        value={dateFrom || ''}
                                        onChange={(e) => { setDateFrom(e.target.value); setSkip(1) }}
                                        className={`form-input-default`}
                                        placeholder="Draw Number"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Date To
                                    </label>
                                    <input
                                        type="date"
                                        value={dateTo || ''}
                                        onChange={(e) => { setDateTo(e.target.value); setSkip(1) }}
                                        className={`form-input-default`}
                                        placeholder="Draw Number"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Brand
                                    </label>
                                    <DropdownwithValue
                                        ref={brandDropdownRef}
                                        options={lotteries}
                                        placeholder='Select a Type'
                                        onSelect={handleBrand}
                                        value={brandValue?.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row ${styles.searchRow}`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Lottery Brand Day
                                    </label>
                                    <DropdownwithValue
                                        ref={brandDayDropdownRef}
                                        options={lotteryBrandDayCode}
                                        placeholder='Select a Brand Day'
                                        onSelect={handleBrandDay}
                                        value={brandDayValue?.name}
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Ticket Status
                                    </label>
                                    <DropdownwithValue
                                        ref={ticketStatusDropdownRef}
                                        options={TicketStatus}
                                        placeholder='Select a Status'
                                        onSelect={handleTicketStatus}
                                        value={ticketStatusValue?.name}
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Payment Status
                                    </label>
                                    <DropdownwithValue
                                        ref={paymentStatusDropdownRef}
                                        options={PaymentStatus}
                                        placeholder='Select a Status'
                                        onSelect={handlePaymentStatus}
                                        value={paymentStatusValue?.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row ${styles.searchRow}`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Draw No
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-input-default`}
                                        placeholder="Draw No"
                                        value={drawNo || ''}
                                        onChange={(e) => { setDrawNo(e.target.value); setSkip(1) }}
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Name
                                    </label>
                                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                                </div>
                            </div>
                            <button
                                className={`btn-primary`}
                                type='button'
                                style={{ height: '49px', marginTop: '25px' }}
                                onClick={clearAll}>
                                <FontAwesomeIcon icon={faRefresh} />
                            </button>
                        </div>
                    </div>
                    <div className={`search-card-body`}>
                        {isTicketReportsLoading ? (
                            <Skeleton
                                columns={["Serial No", "Brand Day", "Draw Date", "Draw No", "Payment Status", "Ticket Status"]}
                                rowCount={10}
                                height={20}
                            />
                        ) : ticketReports.length > 0 ? (
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Serial No</th>
                                            <th>Brand Day</th>
                                            <th>Draw Date</th>
                                            <th>Draw No</th>
                                            <th>Payment Status</th>
                                            <th>Ticket Status</th>
                                            {ticketStatusValue?.name === 'Win' && <th>Winning Price</th>}
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {ticketReports?.map((ticketReport) => (
                                            <tr key={ticketReport.id}>
                                                <td className={`tdataColumnOne`}>{ticketReport.code}</td>
                                                <td>{ticketReport.lottery.lottery_brand_day.name}</td>
                                                <td>{ticketReport.lottery.draw_date}</td>
                                                <td>{ticketReport.lottery.draw_no}</td>
                                                <td>{ticketReport.payment_status}</td>
                                                <td>{ticketReport.ticket_status}</td>
                                               {ticketStatusValue?.name === 'Win' && <td>{ticketReport.winning_price}</td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <NoResultsFound />
                        )}
                    </div>
                    <div className={`search-card-footer`}>
                        {pageCount > 0 && (
                            <div className={styles.paginationContainer}>
                                <Pagination
                                    currentPage={skip}
                                    totalPages={pageCount}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </>
    );
};

export default TicketReports;
